// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"e74afa28","483":"d508b3a9","622":"59c194a1","925":"7a09f3d6","976":"cf3ebe18"}[chunkId] + ".chunk.css";
};